query GetEventsSummary {
  eventsSummary {
    upcomingCount
    pastCount
  }
}
